/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, IWrapHTTPConfig } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProducerForm } from '../models/producer-form';
import { ResponseProducerDto } from '../models/response-producer-dto';

@Injectable({
  providedIn: 'root',
})
export class AdminProducersApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getProducer
   */
  static readonly GetProducerPath = '/api/v1/admin/producers';

  /**
   * Get producer
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProducer()` instead.
   *
   * This method doesn't expect any request body.
   */
  private getProducer$Response(params?: {
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<ResponseProducerDto>> {

    const rb = new RequestBuilder(this.rootUrl, AdminProducersApiService.GetProducerPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResponseProducerDto>;
      })
    );
  }

  /**
   * Get producer
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProducer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProducer(params?: {
  }, config?: IWrapHTTPConfig
): Observable<ResponseProducerDto> {

    return this.wrapHTTPQuery(this.getProducer$Response(params, config).pipe(
      map((r: StrictHttpResponse<ResponseProducerDto>) => r.body as ResponseProducerDto)
    ), config);
  }

  /**
   * Path part for operation updateProducer
   */
  static readonly UpdateProducerPath = '/api/v1/admin/producers';

  /**
   * Update producer
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProducer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  private updateProducer$Response(params: {
    body: ProducerForm
  }, config?: IWrapHTTPConfig
): Observable<StrictHttpResponse<ResponseProducerDto>> {

    const rb = new RequestBuilder(this.rootUrl, AdminProducersApiService.UpdateProducerPath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    }, config)).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResponseProducerDto>;
      })
    );
  }

  /**
   * Update producer
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateProducer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProducer(params: {
    body: ProducerForm
  }, config?: IWrapHTTPConfig
): Observable<ResponseProducerDto> {

    return this.wrapHTTPQuery(this.updateProducer$Response(params, config).pipe(
      map((r: StrictHttpResponse<ResponseProducerDto>) => r.body as ResponseProducerDto)
    ), config);
  }

}
